import { render, staticRenderFns } from "./MerchantDialog.vue?vue&type=template&id=72d07522&scoped=true&"
import script from "./MerchantDialog.vue?vue&type=script&lang=ts&"
export * from "./MerchantDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d07522",
  null
  
)

export default component.exports